import React, {Fragment} from 'react';

import {DebouncedInput} from 'app/general/primitives/DebouncedInput';
import {gt} from 'app/utils/i18n';

import type {StepEditFieldProps} from '../commonprops';

export const StepEditFileField = ({
  label,
  onChange,
  optionsButton,
}: StepEditFieldProps) => (
  <Fragment>
    <div className="input-group">
      <DebouncedInput
        className="form-control"
        type="text"
        value={label}
        onChange={onChange}
        placeholder={gt('File field label...')}
      />
      {optionsButton}
    </div>
    <div className="input-group">
      <input
        className="form-control ext-black-50"
        disabled
        type="text"
        value={gt('File picker will be shown here.')}
      />
      <div className="input-group-append">
        <span className="input-group-text">{gt('Browse')}</span>
      </div>
    </div>
  </Fragment>
);
